import React from 'react';
import Card from 'react-bootstrap/Card';

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: 'justify' }}>
          I am a 4th Year student pursuing Bachelor's of Engineering , IT from
            <b className="purple"> NSIT ,Delhi &nbsp;</b>
            <br />
            <br/>
            <b className="purple">

           Passionate </b>to develop new technology and love to solve real world problems by using the Tech.
            
            <br/><br/> 
            <b className="purple"> Adaptive , team player</b> always up for new challenges. 
            <br/><br/> 
             My Area of Intrest are <b className="purple"> Web Development, Blockchain , &nbsp;Augmented Reality </b> Domains.
            
          </p>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
